import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AlertService, MemberService } from '../../../services';
import { combineLatest, StorageUtil, Subscription } from '../../../store';

@Component({
  selector: 'app-assign-player-team',
  templateUrl: './assign-player-team.component.html',
  styleUrls: ['./assign-player-team.component.css']
})
export class AssignPlayerTeamComponent implements OnChanges {
  @Input() teams;
  @Input() users;
  @Input() isRecreationBilling;
  @Output() cancel = new EventEmitter();
  @Output() save = new EventEmitter();

  filteredTeams = [];

  form: FormGroup;
  sub: Subscription = new Subscription();

  constructor(
    private fb: FormBuilder,
    private memberService: MemberService,
    private alertService: AlertService,
  ) {
    this.form = this.fb.group({
      gender: [null, Validators.required],
      teamType: [null, Validators.required],
      removeFromOtherTeams: [null],
      teamID: [null]
    });
  }

  ngOnChanges() {
    this.sub.add(
      combineLatest(
        this.form.controls.gender.valueChanges,
        this.form.controls.teamType.valueChanges,
        (gender, type) => {
          this.filteredTeams = this.teams.filter(t => (gender === 'b' || t.teamGender.toLowerCase() === gender || t.teamGender === 'b') && +t.teamTypeID === +type);
        }
      ).subscribe()
    );

    if (this.users.every(m => m.gender === 'Male' || m.gender === 'm')) {
      this.form.controls.gender.setValue('m');
      this.form.controls.gender.disable();
    } else if (this.users.every(m => m.gender === 'Female' || m.gender === 'f')) {
      this.form.controls.gender.setValue('f');
      this.form.controls.gender.disable();
    } else {
      this.form.controls.gender.enable();
    }
  }

  onSave(event) {
    event.target.innerHTML = 'Saving <i class="fa fa-spinner fa-spin push-5-r"></i>';
    event.target.disabled = true;
    // console.log('User ID - ', this.selectedMembers.userID);
    const memberIDs: string[] = this.users.map(a => a.userID);

    const bodyReqParameters = {
      memberIDs: memberIDs,
      teamID: +this.form.value.teamID,
      clubAdminID: +StorageUtil.userID,
      removeFromOtherTeams: this.form.value.removeFromOtherTeams,
    };

    this.memberService.setMemberToTeam(bodyReqParameters).subscribe((response: any) => {
      this.alertService.success(response.result);
      event.target.innerHTML = 'Save';
      event.target.disabled = false;
      this.save.emit();
      this.form.reset();
    }, error => {
      event.target.innerHTML = 'Save';
      event.target.disabled = false;
      this.alertService.info(error.error);
    });
  }

  onClose(event: Event) {
    event.stopPropagation();
    this.cancel.emit();
    this.form.reset();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/assign-player-team/assign-player-team.component.ts